// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1eLd5","header":"PatientQuestionnaire_header__2S_zI","info":"PatientQuestionnaire_info__1eLPd"};